<template>
    <div class="vertical-menu">
        <router-link
            v-for="(chapter, key) in $global.chapters[$route.meta.category]"
            :key="key"
            :lal="key"
            :to="key"
        >
            {{ chapter }}
        </router-link>
    </div>
</template>

<script>
export default {
    name: 'verticalMenu',
};
</script>

<style scoped lang="sass">
.vertical-menu
    width: 100%
    height: 100%
    background-color: #eee

    a
        background-color: #eee
        color: black
        display: block
        padding: 12px
        text-decoration: none
        cursor: pointer

        &:hover,
        &.active
            background-color: rgba(224, 81, 32, 0.8)
            color: white
</style>
